import 'devextreme/dist/css/dx.light.css';
import './App.css';
import 'devextreme/dist/css/dx.light.css';
import { Route, Routes } from 'react-router-dom';

import MainNavbar from './apps/main-navbar/main-navbar';
import AuthProvider, { useAuth } from './apps/auth/auth-provider/auth-provider';
import { PrivateRoute } from './apps/auth/private-route/private-route';
import AppLogout from './apps/auth/auto-logout/auto-logout';
import EnterMobileNumber from './apps/auth/logins/otp-login/enter-mobile-number';
import StickyFooter from './apps/footer/sticky-footer/sticky-footer';
import { loadMessages, locale } from 'devextreme/localization';
import faMessage from "../src/shared/fa.json";
import { useEffect, useState } from 'react';
import TransactionExpirationDuration from './apps/transaction-expiration-duration/transaction-expiration-duration';
import { AdminRoute } from './apps/auth/admin-route/admin-route';
import AccountBalanceProvider from './apps/custom-providers/account-balance-provider/account-balance-provider';
import DateTimeProvider from './apps/custom-providers/date-time-provider/date-time-provider';
import DrawerMenu from './apps/drawer-menu/drawer-menu';
import OpenDrawerProvider from './apps/custom-providers/open-drawer-provider/open-drawer-provider';
import QuantityDefinitionProvider from './apps/custom-providers/quantity-definition-provider/quantity-definition-provider';
import RealTimeGoldPriceProvider from './apps/custom-providers/gold-price-provider/RealTimeGoldPriceProvider';
import GoldPriceTypeProvider from './apps/custom-providers/gold-price-type-provider/GoldPriceTypeProvider';
import DimensionProvider from './apps/custom-providers/dimension-provider/DimensionProvider';
import GoldTradingPlatformLoadingProvider from './apps/custom-providers/gold-trading-platform-loading-provider/GoldTradingPlatformLoadingProvider';
import { TransactionOrderTypeProvider } from './apps/custom-providers/transaction-order-type-provider/TransactionOrderTypeProvider';
import { ReceiptApprovationTypeProvider } from './apps/custom-providers/receipt-approvation-type-provider/ReceiptApprovationTypeProvider';
import PriceMarkupTypeProvider from './apps/custom-providers/price-markup-type-provider/PriceMarkupTypeProvider';
import PriceMarkupChangeTypeProvider from './apps/custom-providers/price-markup-change-type-provider/PriceMarkupChangeTypeProvider';
import RealTimeGoldPriceIsActiveProvider from './apps/custom-providers/real-time-gold-price-is-active-provider/RealTimeGoldPriceIsActiveProvider';
import ProfileDetailProvider from './apps/custom-providers/profile-detail-provider/ProfileDetailProvider';
import AdminGoldPriceTypeProvider from './apps/custom-providers/admin-gold-price-type-provider/AdminGoldPriceTypeProvider';


function App() {
  const [locale, setLocale] = useState('fa');
  
  useEffect(() => { 
    loadMessages(faMessage);
  }, [])
  
  return (
    <>
      <DimensionProvider>
        <main className='main'>
          <AuthProvider>
            <Routes>
              <Route
                  path='/login'
                  element={<EnterMobileNumber />}
              ></Route>
            </Routes>
            
            {/* <PriceMarkupChangeTypeProvider>
              <ProfileDetailProvider>
              <PriceMarkupTypeProvider>
              <ReceiptApprovationTypeProvider>
                <TransactionOrderTypeProvider> */}
                  {/* <RealTimeGoldPriceProvider>
                  <RealTimeGoldPriceIsActiveProvider> */}
                  {/* <DateTimeProvider> */}
                  <AppLogout>
                    {/* <AdminGoldPriceTypeProvider>
                    <GoldPriceTypeProvider>
                    <AccountBalanceProvider>

                    <QuantityDefinitionProvider> */}
                      {/* <OpenDrawerProvider> */}
                        {/* <GoldTradingPlatformLoadingProvider> */}
                          <MainNavbar />
                          <DrawerMenu />
                        {/* </GoldTradingPlatformLoadingProvider> */}
                      {/* </OpenDrawerProvider> */}
                    
                      <Routes>
                          <Route element={<PrivateRoute />}>
                            <Route element={<AdminRoute />}>
                            <Route 
                              path="transaction-expiration-durations/:userId"
                              element={<TransactionExpirationDuration />}
                              />
                            </Route>
                          </Route>
                      </Routes>
                    {/* </QuantityDefinitionProvider>
                    
                      </AccountBalanceProvider>
                    </GoldPriceTypeProvider>

                    </AdminGoldPriceTypeProvider> */}

                  </AppLogout>
                  {/* </DateTimeProvider> */}
                  {/* </RealTimeGoldPriceIsActiveProvider>
                  </RealTimeGoldPriceProvider> */}
                {/* </TransactionOrderTypeProvider>
              </ReceiptApprovationTypeProvider>
              </PriceMarkupTypeProvider>
              </ProfileDetailProvider> */}

            {/* </PriceMarkupChangeTypeProvider> */}

            {/* <StickyFooter /> */}
          </AuthProvider>
        </main>

      </DimensionProvider>

    </>
  );
}

export default App;
